import * as React from 'react';
import PropTypes from 'prop-types';
import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
import { IntegratedPriceFreezeProvider } from '@edreamsodigeo/frontend-price-freeze';
import { useUser } from '@edreamsodigeo/frontend-user-authentication';
export const PriceFreezeTranslationsProvider = createTranslationsPageProvider({
  'price-freeze': ({
    brand,
    locale
  }) => import(/* webpackChunkName: "i18n-price-freeze-[request]" */
  `@edreamsodigeo/frontend-price-freeze/translations/${brand}/${locale}/default.js`),
  prime: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "i18n-price-freeze-prime-[request]" */`@edreamsodigeo/frontend-prime/translations/${brand}/${locale}/default.js`)
});
const IntegratedPriceFreezeFunnelProvider = ({
  children
}) => {
  const loginProps = useUser(true);
  return /*#__PURE__*/React.createElement(IntegratedPriceFreezeProvider, {
    loginProps: loginProps
  }, children);
};
IntegratedPriceFreezeFunnelProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default function PriceFreezeFunnelProvider({
  children
}) {
  return /*#__PURE__*/React.createElement(IntegratedPriceFreezeFunnelProvider, null, children);
}
PriceFreezeFunnelProvider.propTypes = {
  children: PropTypes.node.isRequired
};